import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router';

export const usePageTracking = () => {
  const location = useLocation();
  const { initialize, isInitialized, send } = ReactGA;
  const googleAnalyticsID = `${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`;

  useEffect(() => {
    if (!isInitialized && googleAnalyticsID && googleAnalyticsID.length > 0) {
      initialize(googleAnalyticsID);
    }
  }, [isInitialized, googleAnalyticsID, initialize]);

  useEffect(() => {
    if (isInitialized) {
      send({ hitType: 'pageview', page: location.pathname });
    }
  }, [location, isInitialized, send]);
};
